// Auth header direction-aware reveal: the whole sticky header slides up by band 1's
// height on scroll-down (only band 2 stays) and back in on scroll-up. The slide is a
// CSS transform keyed off data-pinned; this file measures the heights and flips
// data-pinned with directional hysteresis.
(function () {
    const header = document.querySelector('header#header[data-theme]');
    if (!header) return;

    const band1 = header.querySelector('[data-headroom-band1]');
    const band2 = header.querySelector('[data-headroom-band2]');

    // Min sustained travel in one direction before the pin flips; a reversal resets
    // the accumulator so touchpad/momentum jitter doesn't flip state mid-transition.
    const PIN_TOLERANCE = 16;

    // Force-pinned below this scrollY. Band 3 fades but keeps its layout space, so
    // forcing pinned until the page scrolls past the collapsible height means the
    // content sits flush under band 2 on collapse and the faded band 3 never reveals
    // a gap. Floored at 1 so we never force-pin the whole document.
    let topThreshold = 80;

    let lastY = window.scrollY;
    let pinned = true;
    let accum = 0;
    let ticking = false;

    function measure() {
        if (band1) {
            header.style.setProperty('--band1-h', band1.offsetHeight + 'px');
        }
        const collapsible = header.offsetHeight - (band2 ? band2.offsetHeight : 0);
        topThreshold = Math.max(1, collapsible);
    }

    function setPinned(next) {
        if (next === pinned) return;
        pinned = next;
        header.setAttribute('data-pinned', next ? 'true' : 'false');
        accum = 0;
    }

    function update() {
        const y = Math.max(0, window.scrollY);
        const delta = y - lastY;
        lastY = y;
        ticking = false;

        if (y < topThreshold) {
            accum = 0;
            setPinned(true);
            return;
        }

        if ((delta > 0 && accum < 0) || (delta < 0 && accum > 0)) {
            accum = 0;
        }
        accum += delta;

        if (accum <= -PIN_TOLERANCE) {
            setPinned(true);
        } else if (accum >= PIN_TOLERANCE) {
            setPinned(false);
        }
    }

    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    }

    measure();
    header.setAttribute('data-pinned', 'true');
    window.addEventListener('scroll', onScroll, { passive: true });

    // Re-measure on size changes (banners, font swap, resize) so --band1-h and the
    // threshold stay correct.
    if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(measure).observe(header);
    }
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(measure);
    }
})();
